/** Default tldraw sync endpoint when `REACT_APP_WHITEBOARD_SYNC_URI_TEMPLATE` is unset. */
export const DEFAULT_SYNC_URI_TEMPLATE = 'wss://dash-whiteboards.minsky.ai/connect/{roomId}';

export function getWhiteboardSyncUriTemplate() {
    return process.env.REACT_APP_WHITEBOARD_SYNC_URI_TEMPLATE || DEFAULT_SYNC_URI_TEMPLATE;
}

export const buildSyncUri = (template, roomId) => {
    const safeRoomId = encodeURIComponent(roomId);
    if (!template) return DEFAULT_SYNC_URI_TEMPLATE.replace('{roomId}', safeRoomId);
    if (template.includes('{roomId}')) return template.replaceAll('{roomId}', safeRoomId);
    return template;
};

/**
 * WebSocket URL used by `useSync` and by room warmup.
 * `storeId` is a tldraw client reserved param; omit it for warmup sockets.
 */
export const buildSyncWebSocketUrl = (uriTemplate, whiteboardId, sessionId, storeId) => {
    const uriString = buildSyncUri(uriTemplate, whiteboardId);
    const withParams = new URL(uriString);
    if (withParams.searchParams.has('sessionId')) {
        throw new Error('useSync "sessionId" is a reserved query param name');
    }
    if (withParams.searchParams.has('storeId')) {
        throw new Error('useSync "storeId" is a reserved query param name');
    }
    withParams.searchParams.set('sessionId', sessionId);
    if (storeId) {
        withParams.searchParams.set('storeId', storeId);
    }
    return withParams.toString();
};

export function toWebSocketUrl(url) {
    return String(url || '').replace(/^http(s)?:/i, 'ws$1:');
}
